const apiConfig = {
  baseURL: process.env.REACT_APP_API_URL || 'https://trello-back.shpp.me/vmedvid/api/v1',
};

export default apiConfig;
